import * as React from 'react'

import { getVisitStatusLabel } from '../visit.helpers'

import type { VisitStatusId } from '../visit.interface'

interface Props {
  className?: string
  status?: VisitStatusId
}

const VisitStatus = function ({ className, status }: Props) {
  const value = status ? getVisitStatusLabel(status) : '–'
  return <span className={className}>{value}</span>
}

export default VisitStatus
